import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Audio from "../../../ui-components/Audio";

import "../../../../assets/styles/numeracy-question.css";

export default function DragAndDrop({
	question,
	onAnswer = () => {},
	onDrag = () => {},
}) {
	const [selected, setSelected] = React.useState(null);
	const [questions, setQuestions] = React.useState(question.questionList);

	const containerRef = React.useRef();

	const handleListChange = (item) => {
		let newList = questions.map((q) => q.id);

		if (selected === null) {
			setSelected(item);
		} else {
			const item1Index = newList.indexOf(selected),
				item2Index = newList.indexOf(item);
			newList[item1Index] = item;
			newList[item2Index] = selected;
			setQuestions(
				newList.map((i) => {
					return { id: i };
				})
			);
			setSelected(null);

			onAnswer({
				canProceed: true,
				answer: newList,
			});
		}
	};

	return (
		<React.Fragment>
			{question.questionHtml && (
				<Box
					sx={{
						width: "100%",
						background: "white",
						pb: 2,
						pt: 1,
						px: { xs: 3, sm: 7 },
						textAlign: "left",
					}}
					className="image-container"
				>
					<div
						dangerouslySetInnerHTML={{
							__html: question.questionHtml,
						}}
					/>
				</Box>
			)}
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionAudio && (
					<Audio audioText={question.questionAudio} />
				)}
				<div ref={containerRef} style={{ paddingTop: "1rem" }}>
					{questions.map((item) => (
						<Grid
							key={item.id}
							container
							className="disable-select dragHandle"
							sx={{ mb: 1 }}
							onClick={() => handleListChange(item.id)}
						>
							<Grid
								item
								sm={12}
								xs={12}
								className="mc-question-container"
								sx={{
									justifyContent: "center",
									background:
										selected === item.id
											? "#06b6ad"
											: "white",
								}}
							>
								<Typography
									sx={{
										color:
											selected !== item.id
												? "#06b6ad"
												: "white",
										fontWeight: "bold",
									}}
								>
									{item.id}
								</Typography>
							</Grid>
						</Grid>
					))}
				</div>
			</Box>
		</React.Fragment>
	);
}
